module.exports = __webpack_public_path__ + "img/党徽.284a699b.png";